import { render, staticRenderFns } from "./AudioPlate.vue?vue&type=template&id=1daadb19&scoped=true&"
import script from "./AudioPlate.vue?vue&type=script&lang=ts&"
export * from "./AudioPlate.vue?vue&type=script&lang=ts&"
import style0 from "./AudioPlate.vue?vue&type=style&index=0&id=1daadb19&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1daadb19",
  null
  
)

export default component.exports